import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { CustomerCenterService, HomeService } from "../../services";
import { formatDateToYYYYMMDD, formatPhoneNumber } from '../../utils/dateUtils';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
// Import required modules
import { Pagination, Navigation, Autoplay, EffectFade } from 'swiper/modules';
import { toast } from 'react-toastify';
import defaultNewsImage from '../../assets/img/customer-service-center/news-default-img.gif';

// import Popup from "../../components/Popup/Popup";
import Popup2 from "../../components/Popup/Popup2";
// import Popup3 from "../../components/Popup/Popup3";

function HomePC() {
  // Production-safe logging - removed to prevent memory issues
  const navigate = useNavigate();
  const [announcements, setAnnouncements] = useState([]);
  const [galleryItems, setGalleryItems] = useState([]);
  const [galleryLoading, setGalleryLoading] = useState(true);
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({
    name: '',
    contact: ''
  });
  const gallerySliderRef = useRef(null);
  const firstSlideRef = useRef(null);

  const bannerSlides = [
    {
      image: '/images/Main/main-01.jpg',
      title1: '고려23대 고종 홍릉이 위치한',
      title2: '천혜의 명당',
      subtitle: '드넓은 강화평야와 시원한 바다가 보이는<br/>수려한 풍경이 어우러진 곳'
    },
    {
      image: '/images/Main/main-02.jpg',
      title1: '최고급 명품 <b className="hero-title2">디자인 건물</b>',
      subtitle: '고인에게는 품격을! 유족에게는 자부심을!'
    },
    {
      image: '/images/Main/main-03.jpg',
      title1: '사랑하는 고인과의',
      title2: '소중한 추억이 깊어지는 장소',
      subtitle: '사랑하는 가족들과 함께 소중한 추억을 영원히 간직하는 장소'
    },
    {
      image: '/images/Main/main-04.jpg',
      title1: '장엄하고 평온한 분위기의',
      title2: '최고급 봉안당',
      subtitle: '호텔급 인테리어, <br >갤러리 같은 국내 최고 시설의 명품 봉안당'
    },
    {
      image: '/images/Main/main-05.jpg',
      title1: '햇살이 가득한 품격 있고',
      title2: '아늑한 쉼터',
      subtitle: '시원하고 탁 트인 전경과 공원으로 조성된 품격있는 추모관'
    }
  ];

  const fetchAnnouncements = async () => {
    try {
      setLoading(true);
      const apiData = await CustomerCenterService.getAnnouncements({
        page: 1,
        size: 6,
      });
      setAnnouncements(apiData.content);
    } catch (err) {
      console.error('Failed to fetch announcements:', err);
    } finally {
      setLoading(false);
    }
  };


  const fetchGalleryList = async () => {
    try {
      const apiData = await HomeService.getGalleryList({
        page: 1,
        size: 6,
      });
      setGalleryItems(apiData.content);
      setGalleryLoading(false);
    } catch (err) {
      console.error('Failed to fetch gallery list:', err);
    }
  };

  // Initial load
  useEffect(() => {
    fetchAnnouncements();
    fetchGalleryList();
  }, []); // Only run on component mount

  // Utility function to format content and remove images
  const formatContent = (htmlContent) => {
    if (!htmlContent) return '';

    // Create a temporary div to parse HTML
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlContent;

    // Remove all img tags
    const images = tempDiv.querySelectorAll('img');
    images.forEach(img => img.remove());

    // Get the text content and format it
    let textContent = tempDiv.textContent || tempDiv.innerText || '';

    // Clean up extra whitespace and line breaks
    textContent = textContent
      .replace(/\s+/g, ' ') // Replace multiple spaces with single space
      .replace(/\n\s*\n/g, '\n') // Replace multiple line breaks with single
      .trim();

    // Limit the content length for preview (e.g., 150 characters)
    if (textContent.length > 25) {
      textContent = textContent.substring(0, 25) + '...';
    }

    return textContent;
  };

  const getSlideWidth = () => {
    try {
      if (firstSlideRef.current) {
        const slideWidth = firstSlideRef.current.offsetWidth;
        const computed = window.getComputedStyle(gallerySliderRef.current);
        const gap = parseInt(computed.columnGap || computed.gap || '0', 10) || 0;
        return slideWidth + gap;
      }
    } catch (_) { }
    // Fallback: scroll a quarter of the container width
    return (gallerySliderRef.current?.clientWidth || 0) / 4;
  };

  const handleNext = () => {
    if (!gallerySliderRef.current) return;
    const delta = getSlideWidth();
    gallerySliderRef.current.scrollBy({ left: delta, behavior: 'smooth' });
  };

  const handlePrev = () => {
    if (!gallerySliderRef.current) return;
    const delta = getSlideWidth();
    gallerySliderRef.current.scrollBy({ left: -delta, behavior: 'smooth' });
  };

  // Form handlers
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // For contact field, only allow numbers
    if (name === 'contact') {
      const numericValue = value.replace(/[^0-9]/g, '');
      setFormData(prev => ({
        ...prev,
        [name]: numericValue
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    // Handle form submission here
    console.log('Form submitted:', formData);
    try {
      const apiData = await HomeService.submitContactForm({
        userName: formData.name,
        userPhone: formData.contact
      });
      console.log('API response:', apiData);
      toast.success('상담 예약이 접수되었습니다.');
      setFormData({ name: '', contact: '' });
    } catch (error) {
      toast.error(error.response.data.message);
      console.error('Failed to submit contact form:', error.response.data.message);
    }

  };

  return (
    <div className="pc-frame page-home home-pc">


      {/* Hero Banner with Swiper */}
      <section className="hero-banner">
        <Swiper
          navigation={true}
          pagination={{ clickable: true }}
          modules={[Pagination, Navigation, Autoplay, EffectFade]}
          effect="fade"
          spaceBetween={0}
          slidesPerView={1}
          loop={true}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          className="mySwiper hero-swiper"
        >
          {bannerSlides.map((slide, index) => (
            <SwiperSlide key={index}>
              <div
                className="hero-slide"
                style={{
                  background: `url('${slide.image}') center/cover`,
                }}
              >
                <div className="hero-content">
                  <h1 className="hero-title" dangerouslySetInnerHTML={{ __html: slide.title1 }} />
                  <h1 className="hero-title2" dangerouslySetInnerHTML={{ __html: slide.title2 }} />
                  <p className="hero-subtitle" dangerouslySetInnerHTML={{ __html: slide.subtitle }} />
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

      </section>

      {/* Main Content */}
      <main className="main-content-home">
        {/* Introduction Section */}
        <section className="intro-text-section">
          <h2 className="home-pc-section-title">
            <span className="title-line-1">강화파라다이스 추모원은</span>
            <span className="title-line-2">함께하는 시간이 행복한 공간입니다.</span>
          </h2>
        </section>

        {/* Three Column Layout */}
        <section className="three-column-layout">
          <div className="content-card">
            <img
              src="/images/Main/A_side_01.jpg"
              alt="실내봉안당"
              className="card-image"
            />
            <div className="card-content">
              <h3 className="card-title">실내봉안당</h3>
              <p className="card-description">
                호텔급 인테리어와 갤러리형 하늘 전망, 최적의 자연광이 가득한 최고급 봉안당입니다.
                100% 밀폐형 특허 납골단위로 고인과 유족 모두에게 품격 있는 공간을 제공합니다.
              </p>
              <button type="button" className="card-link" onClick={() => navigate('/s-hall')}>더보기</button>
            </div>
          </div>

          <div className="content-card">
            <img
              src="/images/Main/A_side_02.jpg"
              alt="가족묘"
              className="card-image"
            />
            <div className="card-content">
              <h3 className="card-title">가족묘</h3>
              <p className="card-description">
                한반도 중심 명산 고려산에 위치한 가족묘입니다.
                강화 평야 너머 바다가 보이는 시원하고 탁 트인 전경, 하루종일 충분한 햇빛과 수려한 경관을 자랑합니다.
              </p>
              <button type="button" className="card-link" onClick={() => navigate('/family-hall')}>더보기</button>
            </div>
          </div>

          <div className="content-card">
            <img
              src="/images/Main/A_side_03.jpg"
              alt="야외가족납골당"
              className="card-image"
            />
            <div className="card-content">
              <h3 className="card-title">야외가족납골당</h3>
              <p className="card-description">
                현대적이고 품격 있는 야외 공원형 대가족 납골당입니다.
                실내 봉안당 대비 합리적인 분양가와 넉넉한 납골단위, 공원으로 조성된 품격 있는 안장지입니다.
              </p>
              <button type="button" className="card-link" onClick={() => navigate('/outdoor-hall')}>더보기</button>
            </div>
          </div>
        </section>

        {/* Teal Sidebar Section */}
        <section className="teal-sidebar-section">
          <div className="interior-hall-section">
            <div className="teal-sidebar">
              <div className="sidebar-content">
                <h3 className="sidebar-title">분양안내</h3>
                <h2 className="sidebar-main-title">최고급 봉안당</h2>
                <p className="sidebar-text">
                  파라다이스추모원의  초고급  시설을 <br />
                  한자리에  모았습니다 .
                </p>
                <button type="button" className="card-link" onClick={() => navigate('/sky-special-room')}>더보기</button>
              </div>
            </div>
            <div className="interior-images">
              <div className="image-carousel">
                <img
                  src="/images/Main/group-85.png"
                  alt="Interior Hall with Framed Pictures"
                  className="interior-image"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Plaza Section */}
        <section
          className="memorial-plaza-section"
          style={{
            backgroundImage: "url('/images/Main/momorial-img.png')",
          }}
        >
          <div className="memorial-plaza-bg">
            <div className="memorial-plaza-links">
              <a onClick={() => navigate('/cyber-memorial-search')} className="memorial-plaza-link-item">
                <div className="memorial-icon-wrapper">
                  <img src="/images/Main/2_178.svg" className="memorial-icon-bg" alt="" />
                  <img src="/images/Main/memo1.png" className="memorial-icon-fg" alt="" />
                </div>
                <span>사이버추모관</span>
              </a>
              <a onClick={() => navigate('/letter-to-heaven-board-list')} className="memorial-plaza-link-item">
                <div className="memorial-icon-wrapper">
                  <img src="/images/Main/2_182.svg" className="memorial-icon-bg" alt="" />
                  <img src="/images/Main/memo2.png" className="memorial-icon-fg" alt="" />
                </div>
                <span>하늘로 보내는 편지</span>
              </a>
              <a onClick={() => navigate('/ancestral-tablet')} className="memorial-plaza-link-item">
                <div className="memorial-icon-wrapper">
                  <img src="/images/Main/2_186.svg" className="memorial-icon-bg" alt="" />
                  <img src="/images/Main/memo3.png" className="memorial-icon-fg" alt="" />
                </div>
                <span>지방출력</span>
              </a>
              <a onClick={() => navigate('/management-fee-payment-inquiry')} className="memorial-plaza-link-item">
                <div className="memorial-icon-wrapper">
                  <img src="/images/Main/2_194.svg" className="memorial-icon-bg" alt="" />
                  <img src="/images/Main/memo4.png" className="memorial-icon-fg" alt="" />
                </div>
                <span>관리비 납부 조회</span>
              </a>
            </div>
          </div>
        </section>

        {/* Info Board Section */}
        <section className="info-board-section">
          <div className="home-announcement-section">
            <div className="info-board-grid">
              <div className="announcements-column">
                <div className="section-header">
                  <h2>공지사항</h2>
                  <img src="/images/Main/btn-more.png" alt="더보기" className="plus-button" onClick={() => navigate('/announcements')} />
                </div>
                <div className="announcements-list">
                  {loading ? (
                    <p>Loading announcements...</p>
                  ) : announcements.length === 0 ? (
                    <p>No announcements available.</p>
                  ) : (
                    announcements.slice(0, 3).map((announcement, index) => (
                      <article key={index} className="announcement-item" onClick={() => navigate(`/announcements/${announcement.boardId}`)}>
                        <div className="announcement-text">
                          <h3>{announcement.boardTitle}</h3>
                          <p>{formatContent(announcement.boardContents)}</p>
                          <time>{formatDateToYYYYMMDD(announcement.registTime)}</time>
                        </div>
                        <img src="/images/Main/arrow-left.png" alt="arrow" className="arrow-icon" />
                      </article>
                    ))
                  )}
                </div>
              </div>
              <div className="explore-column">
                <div className="section-header explore-section-header">
                  <h2>둘러보기</h2>
                  <img src="/images/Main/btn-more.png" alt="더보기" className="plus-button" onClick={() => navigate('/overall-view')} />
                </div>
                <div className="explore-card">
                  <div className="explore-banner">
                    <div className="explore-banner-content">
                      <div className="explore-vr-icon">
                        <img src="/images/Main/6718e4b3e788ab3285aa80a70d3f649b2c1db480.png" alt="360 VR" />
                      </div>
                      <div className="explore-vr-text">
                        <p>추모원의 전체 전경을 <br /> 360도 VR과 이미지를 보실 수 있습니다.</p>
                      </div>
                    </div>
                  </div>
                  <div className="explore-images">
                    <img src="/images/Main/browse2.png" alt="둘러보기 이미지 1" className="img-1" />
                    <img src="/images/Main/browse3.png" alt="둘러보기 이미지 2" className="img-2" />
                    <img src="/images/Main/browse1.png" alt="둘러보기 이미지 3" className="img-3" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Gallery Section */}
        <section className="gallery-section">
          <div className="home-gallery-section">
            <div className="gallery-section-header">
              <h2>추모원 갤러리</h2>
              <img src="/images/Main/btn-more.png" alt="더보기" className="plus-button" onClick={() => navigate('/memorial-gallery-list')} />
            </div>
            <div className="gallery-slider-wrapper">
              <button className="slider-arrow prev-arrow" onClick={handlePrev}>
                <img src="/images/Main/g-arrow-right.png" alt="Previous" />
              </button>
              <div className="gallery-slider" ref={gallerySliderRef}>
                {galleryLoading ? (
                  <div className="gallery-loading">Loading gallery...</div>
                ) : galleryItems.length === 0 ? (
                  <div className="gallery-empty">No gallery items available.</div>
                ) : (
                  galleryItems.map((item, index) => (

                    <div key={item.galleryId || index} className="gallery-slide" ref={index === 0 ? firstSlideRef : null}
                      onClick={() => navigate(`/memorial-gallery-details/${item.galleryId}`)}
                    >
                      <img
                        src={item.photoThumbUrl || defaultNewsImage}
                        alt={item.galleryTitle}
                        onError={(e) => {
                          e.target.src = defaultNewsImage;
                        }}
                      />
                      <div className="slide-overlay" onClick={() => navigate('/memorial-gallery-list')}>
                        <div className="slide-text">
                          <h4>{item.galleryTitle}</h4>
                          <p>{formatDateToYYYYMMDD(item.registTime)}</p>
                        </div>
                      </div>
                    </div>
                  ))

                )}
              </div>
              <button className="slider-arrow next-arrow" onClick={handleNext}>
                <img src="/images/Main/g-arrow-left.png" alt="Next" />
              </button>
            </div>
          </div>
        </section>

        {/* Contact Section */}
        <section className="pc-contact-section">
          <div className="home-contact-section">
            <div className="pc-contact-grid">
              <div className="pc-contact-form-wrapper">
                <div className="pc-section-header">
                  <h2>상담예약</h2>
                </div>
                <div className="pc-contact-form-card">
                  <form className="pc-contact-form" onSubmit={handleFormSubmit}>
                    <div className="form-input-group">
                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        placeholder="이름"
                        className="pc-contact-input"
                        required
                      />
                    </div>
                    <div className="form-input-group">
                      <input
                        type="text"
                        name="contact"
                        value={formData.contact}
                        onFocus={() => {
                          // Remove formatting on focus
                          setFormData((prev) => ({
                            ...prev,
                            contact: prev.contact.replace(/[^0-9]/g, ''),
                          }));
                        }}
                        onBlur={() => {
                          // Format on blur
                          setFormData((prev) => ({
                            ...prev,
                            contact: formatPhoneNumber(prev.contact),
                          }));
                        }}
                        maxLength={11}
                        onChange={handleInputChange}
                        placeholder="연락처"
                        className="pc-contact-input"
                        required
                      />
                    </div>
                    <button type="submit" className="pc-contact-confirm-white">
                      확인
                    </button>
                  </form>
                </div>
              </div>
              <div className="pc-contact-info-wrapper">
                <div className="pc-section-header">
                  <h2>분양상담</h2>
                </div>
                <div className="pc-contact-info-card">
                  <div className="pc-contact-info-content">
                    <div className="pc-phone-icon">
                      <img src="/images/Main/6f1535a6e6b04a5e57886e40bb488997c436d53f.png" alt="" />
                      <img src="/images/Main/d4f2918f4cd7a9d705242b66f93c365e39f79f5b.png" alt="" />
                    </div>
                    <div className="pc-phone-details">
                      <a href="tel:1599-9442" className="pc-phone-number">1599-9442</a>
                      <p>가족분들의 마음의 안식처가 되는추모의 공간입니다.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

      </main>

      {/* <Popup 
        imageUrl="/images/popup/main_popup_chuseok_202609.jpg"
        storageKey="hidePopupToday_MAIN2"
      /> */}

      {/*
      ,
          {
            url: "/images/popup/main_popup_chuseok_202609.jpg",
            link: ""
          }
      */}
      <Popup2
        images={[
          {
            url: "/images/popup/main_popup_mousetrap.png",
            link: "https://www.prds.kr/announcements/333"
          }
        ]}
        storageKey="hidePopupToday_MAIN2"
        autoSlideInterval={5000}
      />
      {/* <Popup3
        images={[
          {
            url: "/images/popup/main_popup_mousetrap.png",
            link: "https://www.prds.kr/announcements/333"
          },
          {
            url: "/images/popup/main_popup_chuseok_202609.jpg",
            link: ""
          }
        ]}
        storageKey="hidePopupToday_MAIN2"
      />*/}

    </div>
  );
}

export default HomePC; 